import { nonNullable, sortBy } from 'lib/array/arrayUtils'
import { getMetresDistanceFromLatLong } from 'lib/flights/getDistanceFromLatLong'

const AIRPORT_DISTANCE_LIMIT_M = 100000

function airportToPlace(
  airport: App.Airport,
  latitude: number,
  longitude: number,
): App.OfferPropertySurroundingsPlace | undefined {
  if (!Number.isFinite(airport.latitude) || !Number.isFinite(airport.longitude)) {
    return
  }

  const distanceM = Math.round(getMetresDistanceFromLatLong(
    latitude,
    longitude,
    airport.latitude,
    airport.longitude,
  ))

  if (!Number.isFinite(distanceM) || distanceM > AIRPORT_DISTANCE_LIMIT_M) {
    return
  }

  return {
    id: airport.code,
    name: `${airport.name} (${airport.code})`,
    distanceM,
    coordinates: {
      lat: airport.latitude,
      lng: airport.longitude,
    },
  }
}

export function getAirportsInRange(
  airports: Array<App.Airport>,
  latitude: number,
  longitude: number,
): Array<App.OfferPropertySurroundingsPlace> {
  return sortBy(
    nonNullable(airports.map((airport) => airportToPlace(airport, latitude, longitude))),
    (airport) => airport.distanceM,
    'asc',
  )
}
